<template>
    <b-table-simple responsive borderless>
        <b-thead>
            <b-tr>
                <b-th class="w-100">Total Variable Expenses</b-th>
                <b-th>Before (RM) (Month)</b-th>
                <b-th>After (RM) (Month)</b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <b-tr v-for="(variable_expense,index) in variable_expenses.data" :key="index">
                <b-td>
                    <p class="font-weight-500 custom-width">{{ variable_expense.customer_question_column }}</p>
                </b-td>
                <b-td>
                    <b-form-input type="number" :disabled="has_report" v-on:input="debounceCustomerInput(variable_expense, variable_expense.customer_month_value)" v-model="variable_expense.customer_month_value"></b-form-input>
                </b-td>
                <b-td class="input-cell">
                    <b-form-input type="number" :disabled="has_report" v-on:input="debounceAdminInput(variable_expense, variable_expense.admin_month_value)" v-model="variable_expense.admin_month_value"></b-form-input>
                </b-td>
            </b-tr>
        </b-tbody>
        <b-tfoot>
            <b-tr class="font-weight-600">
                <b-td>Total Variable Expense</b-td>
                <b-td>{{ total_customer_month | moneyFormatter }}</b-td>
                <b-td>{{ total_admin_month | moneyFormatter }}</b-td>
            </b-tr>
        </b-tfoot>
    </b-table-simple>
</template>
<script>

import { Select, Option } from 'element-ui'
import { axios, services, getKycHeader, debounce, helperFunctionMixin } from '@/assets/js/httpImports.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
    props:['variable_expenses', 'has_report'],
    mixins: [helperFunctionMixin],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            debouncedHandler: '',
            total_customer_month: null,
            total_admin_month: null,
        }
    },
    watch: {
        variable_expenses: {
            handler(newVal) {
                if(newVal && !this.isEmpty(newVal.data) && newVal.data.length > 0) {
                    this.total_customer_month = this.variable_expenses.total.customer_month;
                    let admin_month = this.variable_expenses.data.reduce((total, item) => {
                        const adminValue = parseFloat(item.admin_month_value);
                        if (isNaN(adminValue)) {
                            return total;
                        }
                        return total + adminValue
                    }, 0)
                    this.total_admin_month = admin_month;
                }
            },
            deep: true,
        }
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        debounceCustomerInput: debounce(function (variable_expense, customer_value = null) {
            let new_customer_value = null;
            if(variable_expense.frequency_id == 1)
            {
                new_customer_value = customer_value * 12;
            }
            else
            {
                new_customer_value = customer_value;
            }

            if(customer_value == '')
            {
                new_customer_value = null;
            }

            const postData = {
                customer_form_id: variable_expense.customer_form_id,
                customer_id: variable_expense.customer_id,
                customer_question_id: variable_expense.customer_question_id,
                customer_value : new_customer_value,
            }

            axios.post(services.kyc_api + '/customers/answer', postData, { headers: getKycHeader() })
            .then(response => {
                initialProposalEventBus.$emit('sync-proposal');
            })
            .catch ( error => {
                this.errorFunction(error, "Error Saving After Value") 
            });
        }, 1000),
        debounceAdminInput: debounce(function (variable_expense, admin_value = null) {
            let new_admin_value = null;
            if(variable_expense.frequency_id == 1)
            {
                new_admin_value = admin_value * 12;
            }
            else
            {
                new_admin_value = admin_value;
            }

            if(admin_value == '')
            {
                new_admin_value = null;
            }

            const postData = {
                admin_value : new_admin_value,
            }

            axios.put(services.kyc_api + '/customers/answer/' + variable_expense.answer_id, postData, { headers: getKycHeader() })
            .then(response => {
							initialProposalEventBus.$emit('sync-proposal');
            })
            .catch ( error => {
                this.errorFunction(error, "Error Saving After Value") 
            });
        }, 1000),
    }
}
</script>